import { Typography } from '@mui/material';
import { Column, usePagination, useTable } from 'react-table';
import { ViewContractsTiersGridItem } from 'shared/types/customerManagement';
import {
  viewContractsAgainstVolumeIncentiveTiersTableColumns,
  hiddenColumns,
} from './columns/view-contracts-against-volume-incentive-tiers-table-columns';
import { viewContractsVolumeIncentiveTiersTableColumns } from './columns/view-contracts-volume-incentive-tiers-table-columns';

const defaultColumn: Partial<Column<ViewContractsTiersGridItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 100,
  minWidth: 100,
  maxWidth: 100,
  align: 'inherit',
  hidden: true,
};

const getRowId = (row: ViewContractsTiersGridItem) => row.tier;

export function useViewContractsVolumeIncentiveTiersTableInstance(
  data: Array<ViewContractsTiersGridItem>,
  diffingMode: boolean,
  isDraft: boolean,
  rejectedAndEditMode: boolean
) {
  const columns =
    (diffingMode || isDraft) && !rejectedAndEditMode
      ? viewContractsAgainstVolumeIncentiveTiersTableColumns
      : viewContractsVolumeIncentiveTiersTableColumns;
  const instance = useTable<ViewContractsTiersGridItem>(
    {
      columns,
      data,
      initialState: { pageSize: 15, hiddenColumns },
      defaultColumn,
      getRowId,
      autoResetFilters: false,
    },
    usePagination
  );

  return instance;
}
